import axios from 'axios';
import Vue from 'vue';
import { differenceInSeconds, parseISO } from 'date-fns';

var getGetters = function () {
    return {
        filterString: function (state) {
            var filters = state.filters;
            var str = [];
            for (var p in filters) {
                if (filters.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(filters[p]));
                }
            }
            var filterString = "";
            if (str.length > 0) {
                filterString = "?" + str.join("&");
            }
            return filterString;
        },
        loading: function (state) { return function (action) {
            // Check if the request is in the request queue (if true, then it's loading)
            return !!state.requests[action];
        }; }
    };
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

// Common
var LOADING = "LOADING";
var LOADED = "LOADED";
// Authentication
var SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";
var SET_USER = "SET_USER";
// Models
var SET_LIST = "SET_LIST";
var SET_DETAIL = "SET_DETAIL";
var SET_META = "SET_META";
var SET_OPTIONS = "SET_OPTIONS";
var ADD_FILTERS = "ADD_FILTERS";
var CLEAR_FILTERS = "CLEAR_FILTERS";
var ADD_REQUEST = "ADD_REQUEST";
var REMOVE_REQUEST = "REMOVE_REQUEST";
// Errors
var ADD_ERRORS = "ADD_ERRORS";
var CLEAR_ERRORS = "CLEAR_ERRORS";

var getMutations = function () {
    var _a;
    return _a = {},
        _a[SET_LIST] = function (state, list) {
            state.list = list;
        },
        _a[SET_DETAIL] = function (state, detail) {
            state.detail = detail;
        },
        _a[SET_META] = function (state, meta) {
            state.meta = meta;
        },
        _a[SET_OPTIONS] = function (state, meta) {
            state.options = __assign(__assign({}, state.options), meta);
        },
        _a[ADD_REQUEST] = function (state, action) {
            var CancelToken = axios.CancelToken;
            state.requests[action] = CancelToken.source();
            state.requests = __assign({}, state.requests);
        },
        _a[REMOVE_REQUEST] = function (state, action) {
            delete state.requests[action];
            state.requests = __assign({}, state.requests);
        },
        _a[ADD_FILTERS] = function (state, filters) {
            // parse filter values
            for (var i in filters) {
                if (filters.hasOwnProperty(i)) {
                    if (Array.isArray(filters[i])) {
                        filters[i] = filters[i].join();
                    }
                    if (filters[i] === null) {
                        filters[i] = "";
                    }
                }
            }
            state.filters = __assign(__assign({}, state.filters), filters);
        },
        _a[CLEAR_FILTERS] = function (state) {
            state.filters = {};
        },
        _a[ADD_ERRORS] = function (state, errorObject) {
            state.errors = __assign(__assign({}, errorObject), state.errors);
        },
        _a[CLEAR_ERRORS] = function (state) {
            state.errors = {};
        },
        _a;
};

var logoutEvent = new CustomEvent("logoutEvent");
/**
 * Register an http request with the vuex store
 * @param commit {Commit}
 * @param state {ModelState}
 * @param action {string}
 */
var registerHTTPRequest = function (commit, state, action) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!state.requests[action]) return [3 /*break*/, 6];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 6]);
                return [4 /*yield*/, state.requests[action].cancel()];
            case 2:
                _a.sent();
                commit(REMOVE_REQUEST, action);
                return [3 /*break*/, 6];
            case 3:
                error_1 = _a.sent();
                if (!!axios.isCancel(error_1)) return [3 /*break*/, 5];
                return [4 /*yield*/, Promise.reject(error_1)];
            case 4: return [2 /*return*/, _a.sent()];
            case 5: return [3 /*break*/, 6];
            case 6:
                commit(ADD_REQUEST, action);
                return [2 /*return*/, Promise.resolve(state.requests[action])];
        }
    });
}); };
/**
 * Force a logout event
 */
var forceLogout = function () {
    window.dispatchEvent(logoutEvent);
};

/**
 * Axios request interceptors
 * https://github.com/axios/axios#interceptors
 */
var http = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken"
});
http.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        forceLogout();
    }
    else {
        return Promise.reject(error);
    }
});

/**
 * Return a list of CRUD actions
 * @param { string } endpoint
 * @param { Store } store
 */
// TODO: Preferably we don't want Generic type S extending any
var getActions = function (endpoint) {
    return {
        /**
         * CREATE a new model
         * @param commit
         * @param state
         * @param payload obj {email: '', password: ''}
         */
        create: function (_a, payload) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var cancelToken, response, object, error_1, status_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, "create")];
                        case 1:
                            cancelToken = _b.sent();
                            commit(CLEAR_ERRORS);
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 7]);
                            return [4 /*yield*/, http.post(endpoint + "/", payload, {
                                    cancelToken: cancelToken.token
                                })];
                        case 3:
                            response = _b.sent();
                            object = response.data;
                            commit(REMOVE_REQUEST, "create");
                            commit(SET_DETAIL, object);
                            return [2 /*return*/, response];
                        case 4:
                            error_1 = _b.sent();
                            if (!!axios.isCancel(error_1)) return [3 /*break*/, 6];
                            status_1 = error_1.response ? error_1.response.status : null;
                            commit(REMOVE_REQUEST, "create");
                            if (status_1 === 400) {
                                commit(ADD_ERRORS, error_1.response.data);
                            }
                            return [4 /*yield*/, Promise.reject(error_1)];
                        case 5: return [2 /*return*/, _b.sent()];
                        case 6: return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * LIST model objects
         * @param commit
         * @param state
         * @param getters
         */
        list: function (_a) {
            var commit = _a.commit, state = _a.state, getters = _a.getters;
            return __awaiter(this, void 0, void 0, function () {
                var cancelToken, response, results, meta, error_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, "list")];
                        case 1:
                            cancelToken = _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 7]);
                            return [4 /*yield*/, http.get(endpoint + "/" + getters.filterString, {
                                    cancelToken: cancelToken.token
                                })];
                        case 3:
                            response = _b.sent();
                            results = response.data;
                            // paginated results
                            if (response.data.results) {
                                results = response.data.results;
                                meta = __assign({}, response.data);
                                delete meta.results;
                                commit(SET_META, meta); // meta (e.g count, pages etc)
                            }
                            commit(REMOVE_REQUEST, "list");
                            commit(SET_LIST, results); // list of results
                            return [2 /*return*/, response];
                        case 4:
                            error_2 = _b.sent();
                            if (!!axios.isCancel(error_2)) return [3 /*break*/, 6];
                            commit(REMOVE_REQUEST, "list");
                            return [4 /*yield*/, Promise.reject(error_2)];
                        case 5: return [2 /*return*/, _b.sent()];
                        case 6: return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * model OPTIONS
         * @param commit
         * @param state
         * @param getters
         */
        options: function (_a) {
            var commit = _a.commit, state = _a.state, getters = _a.getters;
            return __awaiter(this, void 0, void 0, function () {
                var cancelToken, response, options, error_3;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, "options")];
                        case 1:
                            cancelToken = _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 7]);
                            return [4 /*yield*/, http.options(endpoint + "/", {
                                    cancelToken: cancelToken.token
                                })];
                        case 3:
                            response = _b.sent();
                            options = response.data;
                            commit(REMOVE_REQUEST, "options");
                            commit(SET_OPTIONS, options);
                            return [2 /*return*/, response];
                        case 4:
                            error_3 = _b.sent();
                            if (!!axios.isCancel(error_3)) return [3 /*break*/, 6];
                            commit(REMOVE_REQUEST, "options");
                            return [4 /*yield*/, Promise.reject(error_3)];
                        case 5: return [2 /*return*/, _b.sent()];
                        case 6: return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * Next model objects
         * @param commit
         * @param state
         */
        next: function (_a) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var cancelToken, response, results, meta, error_4;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!state.meta.next) return [3 /*break*/, 7];
                            return [4 /*yield*/, registerHTTPRequest(commit, state, "list")];
                        case 1:
                            cancelToken = _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 7]);
                            return [4 /*yield*/, http.get(state.meta.next, {
                                    cancelToken: cancelToken.token
                                })];
                        case 3:
                            response = _b.sent();
                            results = response.data.results;
                            meta = __assign(__assign({}, response.data), { results: null });
                            delete meta.results;
                            commit(REMOVE_REQUEST, "list");
                            commit(SET_LIST, results); // list of results
                            commit(SET_META, meta); // meta (e.g count, pages etc)
                            return [2 /*return*/, response];
                        case 4:
                            error_4 = _b.sent();
                            if (!!axios.isCancel(error_4)) return [3 /*break*/, 6];
                            commit(REMOVE_REQUEST, "list");
                            return [4 /*yield*/, Promise.reject(error_4)];
                        case 5: return [2 /*return*/, _b.sent()];
                        case 6: return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * GET a model DETAIL object
         * @param commit
         * @param state
         * @param id Model ID
         */
        detail: function (_a, id) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var cancelToken, response, result, error_5;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, "detail")];
                        case 1:
                            cancelToken = _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 7]);
                            return [4 /*yield*/, http.get(endpoint + "/" + id + "/", {
                                    cancelToken: cancelToken.token
                                })];
                        case 3:
                            response = _b.sent();
                            result = response.data;
                            commit(REMOVE_REQUEST, "detail");
                            commit(SET_DETAIL, result);
                            return [2 /*return*/, Promise.resolve(response)];
                        case 4:
                            error_5 = _b.sent();
                            if (!!axios.isCancel(error_5)) return [3 /*break*/, 6];
                            commit(REMOVE_REQUEST, "detail");
                            return [4 /*yield*/, Promise.reject(error_5)];
                        case 5: return [2 /*return*/, _b.sent()];
                        case 6: return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * UPDATE a model object
         * @param commit
         * @param state
         * @param data
         */
        update: function (_a, data) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var cancelToken, response, result, error_6, status_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, "update")];
                        case 1:
                            cancelToken = _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 7]);
                            return [4 /*yield*/, http.patch(endpoint + "/" + data.id + "/", data.data, {
                                    cancelToken: cancelToken.token
                                })];
                        case 3:
                            response = _b.sent();
                            result = response.data;
                            commit(REMOVE_REQUEST, "update");
                            commit(SET_DETAIL, result);
                            commit(CLEAR_ERRORS);
                            return [2 /*return*/, response];
                        case 4:
                            error_6 = _b.sent();
                            if (!!axios.isCancel(error_6)) return [3 /*break*/, 6];
                            status_2 = error_6.response ? error_6.response.status : null;
                            commit(REMOVE_REQUEST, "update");
                            if (status_2 === 400) {
                                commit(ADD_ERRORS, error_6.response.data);
                            }
                            return [4 /*yield*/, Promise.reject(error_6)];
                        case 5: return [2 /*return*/, _b.sent()];
                        case 6: return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         *
         * DELETE a model object
         * @param commit
         * @param state
         * @param id Model ID
         */
        delete: function (_a, id) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var cancelToken, response, result, error_7;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, "delete")];
                        case 1:
                            cancelToken = _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 7]);
                            return [4 /*yield*/, http.delete(endpoint + "/" + id + "/", {
                                    cancelToken: cancelToken.token
                                })];
                        case 3:
                            response = _b.sent();
                            result = response.data;
                            commit(REMOVE_REQUEST, "delete");
                            commit(SET_DETAIL, result);
                            return [2 /*return*/, response];
                        case 4:
                            error_7 = _b.sent();
                            if (!!axios.isCancel(error_7)) return [3 /*break*/, 6];
                            commit(REMOVE_REQUEST, "delete");
                            return [4 /*yield*/, Promise.reject(error_7)];
                        case 5: return [2 /*return*/, _b.sent()];
                        case 6: return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * Clear CRUD State
         * @param commit
         * @param dispatch
         * @param action
         */
        clearState: function (_a, action) {
            var commit = _a.commit, dispatch = _a.dispatch;
            if (action === void 0) { action = "all"; }
            switch (action) {
                case "list":
                    dispatch("cancel", "list");
                    commit(SET_LIST, []);
                    commit(SET_META, {});
                    break;
                case "all":
                    dispatch("cancel", "list");
                    dispatch("cancel", "detail");
                    dispatch("cancel", "create");
                    dispatch("cancel", "update");
                    dispatch("cancel", "delete");
                    commit(SET_LIST, []);
                    commit(SET_META, {});
                    commit(SET_DETAIL, {});
                    break;
                default:
                    dispatch("cancel", action);
                    commit(SET_DETAIL, {});
                    break;
            }
            commit(CLEAR_ERRORS);
            return;
        },
        cancel: function (_a, action) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var error_8;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!state.requests[action]) return [3 /*break*/, 5];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 5]);
                            return [4 /*yield*/, state.requests[action].cancel("Previous request cancelled")];
                        case 2:
                            _b.sent();
                            commit("" + REMOVE_REQUEST, action);
                            return [3 /*break*/, 5];
                        case 3:
                            error_8 = _b.sent();
                            return [4 /*yield*/, Promise.reject(error_8)];
                        case 4: return [2 /*return*/, _b.sent()];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    };
};
var customAction = function (action, endpoint, type) {
    switch (type) {
        case "list":
            return function (_a) {
                var commit = _a.commit, state = _a.state;
                return __awaiter(void 0, void 0, void 0, function () {
                    var cancelToken, response, error_9;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, action)];
                            case 1:
                                cancelToken = _b.sent();
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 4, , 7]);
                                return [4 /*yield*/, http.get(endpoint, {
                                        cancelToken: cancelToken.token
                                    })];
                            case 3:
                                response = _b.sent();
                                commit(REMOVE_REQUEST, action);
                                return [2 /*return*/, response];
                            case 4:
                                error_9 = _b.sent();
                                if (!!axios.isCancel(error_9)) return [3 /*break*/, 6];
                                commit(REMOVE_REQUEST, action);
                                return [4 /*yield*/, Promise.reject(error_9)];
                            case 5: return [2 /*return*/, _b.sent()];
                            case 6: return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                });
            };
        case "create":
            return function (_a, payload) {
                var commit = _a.commit, state = _a.state;
                return __awaiter(void 0, void 0, void 0, function () {
                    var cancelToken, response, error_10, status_3;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, action)];
                            case 1:
                                cancelToken = _b.sent();
                                commit(CLEAR_ERRORS);
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 4, , 7]);
                                return [4 /*yield*/, http.post(endpoint, payload, {
                                        cancelToken: cancelToken.token
                                    })];
                            case 3:
                                response = _b.sent();
                                commit(REMOVE_REQUEST, action);
                                return [2 /*return*/, response];
                            case 4:
                                error_10 = _b.sent();
                                if (!!axios.isCancel(error_10)) return [3 /*break*/, 6];
                                status_3 = error_10.response ? error_10.response.status : null;
                                commit(REMOVE_REQUEST, action);
                                if (status_3 === 400) {
                                    commit(ADD_ERRORS, error_10.response.data);
                                }
                                return [4 /*yield*/, Promise.reject(error_10)];
                            case 5: return [2 /*return*/, _b.sent()];
                            case 6: return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                });
            };
        case "detail":
            return function (_a, id) {
                var commit = _a.commit, state = _a.state;
                return __awaiter(void 0, void 0, void 0, function () {
                    var cancelToken, response, error_11;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, action)];
                            case 1:
                                cancelToken = _b.sent();
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 4, , 7]);
                                return [4 /*yield*/, http.get(endpoint + "/" + id + "/", {
                                        cancelToken: cancelToken.token
                                    })];
                            case 3:
                                response = _b.sent();
                                commit(REMOVE_REQUEST, action);
                                return [2 /*return*/, Promise.resolve(response)];
                            case 4:
                                error_11 = _b.sent();
                                if (!!axios.isCancel(error_11)) return [3 /*break*/, 6];
                                commit(REMOVE_REQUEST, action);
                                return [4 /*yield*/, Promise.reject(error_11)];
                            case 5: return [2 /*return*/, _b.sent()];
                            case 6: return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                });
            };
        case "update":
            return function (_a, data) {
                var commit = _a.commit, state = _a.state;
                return __awaiter(void 0, void 0, void 0, function () {
                    var cancelToken, response, error_12, status_4;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, "update")];
                            case 1:
                                cancelToken = _b.sent();
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 4, , 7]);
                                return [4 /*yield*/, http.patch(endpoint + "/" + data.id + "/", data.data, {
                                        cancelToken: cancelToken.token
                                    })];
                            case 3:
                                response = _b.sent();
                                commit(REMOVE_REQUEST, action);
                                commit(CLEAR_ERRORS);
                                return [2 /*return*/, response];
                            case 4:
                                error_12 = _b.sent();
                                if (!!axios.isCancel(error_12)) return [3 /*break*/, 6];
                                status_4 = error_12.response ? error_12.response.status : null;
                                commit(REMOVE_REQUEST, action);
                                if (status_4 === 400) {
                                    commit(ADD_ERRORS, error_12.response.data);
                                }
                                return [4 /*yield*/, Promise.reject(error_12)];
                            case 5: return [2 /*return*/, _b.sent()];
                            case 6: return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                });
            };
        case "delete":
            return function (_a, id) {
                var commit = _a.commit, state = _a.state;
                return __awaiter(void 0, void 0, void 0, function () {
                    var cancelToken, response, result, error_13;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, registerHTTPRequest(commit, state, action)];
                            case 1:
                                cancelToken = _b.sent();
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 4, , 7]);
                                return [4 /*yield*/, http.delete(endpoint + "/" + id + "/", {
                                        cancelToken: cancelToken.token
                                    })];
                            case 3:
                                response = _b.sent();
                                result = response.data;
                                commit(REMOVE_REQUEST, action);
                                commit(SET_DETAIL, result);
                                return [2 /*return*/, response];
                            case 4:
                                error_13 = _b.sent();
                                if (!!axios.isCancel(error_13)) return [3 /*break*/, 6];
                                commit(REMOVE_REQUEST, action);
                                return [4 /*yield*/, Promise.reject(error_13)];
                            case 5: return [2 /*return*/, _b.sent()];
                            case 6: return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                });
            };
    }
};

var getState = function () {
    return {
        list: [],
        detail: null,
        loading: false,
        meta: {},
        filters: {},
        requests: {},
        errors: {}
    };
};

var auth = {
    permissions: [],
    loading: false,
    errors: {},
    user: {
        anonymous: true
    }
};

var _a;
var mutations = (_a = {},
    _a[LOADING] = function (state) {
        state.loading = true;
    },
    _a[LOADED] = function (state) {
        state.loading = false;
    },
    _a[ADD_ERRORS] = function (state, errorObject) {
        state.errors = __assign(__assign({}, errorObject), state.errors);
    },
    _a[CLEAR_ERRORS] = function (state) {
        state.errors = {};
    },
    _a[SET_USER] = function (state, user) {
        state.user = user;
    },
    _a[SET_USER_PERMISSIONS] = function (state, permissions) {
        state.permissions = permissions;
    },
    _a);

/**
 * Event hub to manage auth events
 */
var authEvent = new Vue();

var actions = {
    /**
     *Login request
     * @param commit
     * @param user { GenericObject }
     * @param dispatch
     */
    setCurrentUser: function (_a, user) {
        var commit = _a.commit, dispatch = _a.dispatch;
        commit(SET_USER, user);
        if (user && !user.anonymous) {
            authEvent.$emit("login");
        }
    },
    login: function (_a, payload) {
        var _this = this;
        var commit = _a.commit, getters = _a.getters, dispatch = _a.dispatch;
        commit(LOADING);
        commit(CLEAR_ERRORS);
        var http = axios.create({
            baseURL: process.env.VUE_APP_API_BASE_URL
        });
        return http
            .post("account/login/", payload)
            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch("setCurrentUser", response.data)];
                    case 1:
                        _a.sent();
                        authEvent.$emit("login");
                        return [2 /*return*/, Promise.resolve(true)];
                }
            });
        }); })
            .catch(function (err) {
            if (err.response) {
                commit(ADD_ERRORS, err.response.data);
            }
            commit(LOADED);
            dispatch("logout");
        });
    },
    /**
     * Check the current user
     * @param commit
     * @param state
     * @param dispatch
     */
    whoami: function (_a) {
        var commit = _a.commit, state = _a.state, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                return [2 /*return*/, axios
                        .get(process.env.VUE_APP_API_BASE_URL + "/account/users/whoami/")
                        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch("setCurrentUser", response.data)];
                                case 1:
                                    _a.sent();
                                    authEvent.$emit("session_started", response.data);
                                    return [2 /*return*/, Promise.resolve(true)];
                            }
                        });
                    }); })
                        .catch(function (err) {
                        commit(LOADED);
                        return Promise.reject(err);
                    })];
            });
        });
    },
    /**
     * Get the current user permissions in relative to the current entity
     * @param commit
     */
    getUserPermissions: function (_a) {
        var commit = _a.commit;
        // TODO: if performance becomes a concern the permissions can be loaded from a cached detail url with etag
        return http
            .get("/account/users/permissions/")
            .then(function (response) {
            commit(SET_USER_PERMISSIONS, response.data);
            return Promise.resolve(response);
        })
            .catch(function (error) {
            return Promise.reject(error);
        });
    },
    /**
     * Clear tokens and redirect to login
     * @param commit
     * @param dispatch
     */
    logout: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // perform any additional logout operations here
                    return [4 /*yield*/, axios.get(process.env.VUE_APP_API_BASE_URL + "/account/logout/")];
                    case 1:
                        // perform any additional logout operations here
                        _b.sent();
                        commit(SET_USER_PERMISSIONS, []);
                        commit(SET_USER, {
                            anonymous: true
                        });
                        authEvent.$emit("logout");
                        return [2 /*return*/];
                }
            });
        });
    }
};

var getters = {
    /**
     * Check if a user is logged in with an entity id
     * @param state
     */
    loggedIn: function (state) {
        return !!state.user.anonymous;
    },
    /**
     * Check if the user has entity permissions granted on the django backend.
     * The permission string is of format "app_name.permission"
     * e.g this.$store.getters["auth/hasEntityPermission"]("yourapp.view_employees");
     * @param state
     */
    hasEntityPermission: function (state) { return function (permission) {
        return state.permissions.includes(permission);
    }; }
};

var auth$1 = {
    namespaced: true,
    state: auth,
    getters: getters,
    actions: actions,
    mutations: mutations
};

function autoLogout(store) {
    var sessionExpiry = store.state.auth.user.session_expiry_date;
    if (!!sessionExpiry) {
        var timeDifference = differenceInSeconds(parseISO(sessionExpiry), new Date());
        if (timeDifference < 30) {
            store.dispatch("auth/logout");
        }
    }
    return;
}
function DJVuePlugin() {
    return function (store) {
        // Initialize state from localstorage and server
        store.dispatch("auth/whoami").then(function () {
            // Automatically logout an expiring session
            window.setInterval(autoLogout, 30000, store); // 30 seconds
        });
        window.addEventListener("logoutEvent", function () {
            store.dispatch("auth/logout");
        });
    };
}

var install = function (Vue, _a) {
    var store = _a.store;
    // Set resource to djvue axios
    Vue.prototype.$http = http;
    // Register the Bcore Vuex plugin
    var djvuePlugin = DJVuePlugin();
    djvuePlugin(store);
};

var Djvue = {
    install: install
};

export default Djvue;
export { auth$1 as auth, authEvent, customAction, forceLogout, getActions, getGetters, getMutations, getState, http, logoutEvent, registerHTTPRequest };
//# sourceMappingURL=djvue.es.js.map
